<template>
  <div class="pantone" v-if="page && page.pantone">
    <component :is="dataToolbar.component" :items="dataToolbar.items" v-if="dataToolbar"></component>
    <header
      v-if="page.pantone.sticky"
      ref="header"
      :class="{ '-sticky': sticky, '-stickyHeader': stickyHeader, '-withToolbar': dataToolbar}"
    >
      <div class="container">
        <img class="star" src="../assets/img/pantone/star.gif" alt="" />
        <h1 class="title" v-html="page.pantone.sticky.title"></h1>
        <button
          type="button"
          class="btn -icon"
          v-if="isEcommerce && esProduct && esProduct.stock.is_in_stock"
          @click="addToCartAndFeedback(esProduct)"
        >
          <i class="icon-cart"></i><span>{{ $t("Add to cart") }}</span>
        </button>
        <button
          type="button"
          class="btn -icon"
          v-if="
            isEcommerce &&
            esProduct &&
            esProduct.is_shoppable &&
            !esProduct.stock.is_in_stock
          "
          disabled
        >
          <i class="icon-cart"></i><span>{{ $t("Out of stock") }}</span>
        </button>
        <router-link
          v-if="!isEcommerce"
          :to="localizedUrl + '/product/' + page.pantone.product.routeParam"
          class="btn -stroke -icon"
          :aria-label="$t('Discover more')"
        >
          <i :class="'icon-plus'"></i><span>{{ $t("Discover more") }}</span>
        </router-link>
      </div>
    </header>
    <section v-if="page.pantone.header" class="signature">
      <Observer name="fade-up" :class="'delay-0'">
        <video muted autoplay playsinline>
          <source src="/assets/img/pantone/signature.mp4" type="video/mp4" />
        </video>
      </Observer>
      <button
        class="scrollto"
        @click="onClickScrollDown"
        type="button"
        :aria-label="$t('Scroll down')"
      >
        <i class="icon-back-copy"></i>
      </button>
    </section>
    <section v-if="page.pantone.header" class="watch">
      <h2 class="a11y-sr-only" v-html="page.pantone.header.title"></h2>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <Observer name="fade-up" :class="'delay-0'">
              <parallax :from="{ y: 100 }" :to="{ y: -100 }">
                <img
                  src="../assets/img/pantone/watch.png"
                  alt=""
                  slot-scope="{ parallax }"
                  :style="`transform: translate3d(0px, ${
                    parallax && parallax.y ? parallax.y : 0
                  }px, 0px)`"
                />
              </parallax>
            </Observer>
          </div>
          <div class="col-11 col-md-8 col-lg-6 text-center">
            <parallax :from="{ y: -100 }" :to="{ y: 100 }">
              <div
                slot-scope="{ parallax }"
                :style="`transform: translate3d(0px, ${
                  parallax && parallax.y ? parallax.y : 0
                }px, 0px)`"
              >
                <Observer name="fade-down" :class="'delay-0'">
                  <strong
                    class="title"
                    aria-hidden="true"
                    v-html="page.pantone.header.title"
                  ></strong>
                  <p v-html="page.pantone.header.text">
                    {{
                      $t(
                        "ZENITH and Felipe Pantone express high-frequency chronometry through light and colours"
                      )
                    }}
                  </p>
                </Observer>
              </div>
            </parallax>
          </div>
        </div>
      </div>
    </section>
    <section v-if="page.pantone.artwork" class="work">
      <h2 class="a11y-sr-only" v-html="page.pantone.artwork.title"></h2>
      <Observer name="fade-up" :class="'delay-0'">
        <div class="works">
          <parallax :from="{ y: 0 }" :to="{ y: 500 }">
            <img
              src="../assets/img/pantone/work.jpg"
              alt=""
              slot-scope="{ parallax }"
              :style="`transform: translate3d(0px, ${
                parallax && parallax.y ? parallax.y : 0
              }px, 0px)`"
            />
          </parallax>
          <parallax :from="{ y: 500 }" :to="{ y: 0 }">
            <img
              src="../assets/img/pantone/work.jpg"
              alt=""
              slot-scope="{ parallax }"
              :style="`transform: translate3d(0px, ${
                parallax && parallax.y ? parallax.y : 0
              }px, 0px)`"
            />
          </parallax>
        </div>
      </Observer>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <Observer name="fade-up" :class="'delay-0'">
              <parallax :from="{ y: 150 }" :to="{ y: -150 }">
                <img
                  src="../assets/img/pantone/work.jpg"
                  alt="Filipe Pantone work"
                  class="visual"
                  slot-scope="{ parallax }"
                  :style="`transform: translate3d(0px, ${
                    parallax && parallax.y ? parallax.y : 0
                  }px, 0px)`"
                />
              </parallax>
            </Observer>
          </div>
          <div class="col-11 col-md-8 col-lg-6 text-center">
            <Observer name="fade-up" :class="'delay-0'">
              <strong
                class="title"
                aria-hidden="true"
                v-html="page.pantone.artwork.title"
              ></strong>
            </Observer>
            <Observer name="fade-up" :class="'delay-0'">
              <p v-html="page.pantone.artwork.text"></p>
            </Observer>
          </div>
        </div>
      </div>
    </section>
    <section v-if="page.pantone.case" class="case">
      <div class="container">
        <div
          class="
            row
            align-items-end align-items-md-center
            justify-content-center
          "
        >
          <div class="col-11 col-md-7 offset-md-5 col-lg-5 offset-lg-7">
            <Observer name="fade-up" :class="'delay-0'">
              <h2 class="title" v-html="page.pantone.case.title"></h2>
              <p v-html="page.pantone.case.text"></p>
            </Observer>
          </div>
        </div>
      </div>
      <Observer name="fade-up">
        <parallax :from="{ y: -200 }" :to="{ y: 200 }">
          <img
            src="../assets/img/pantone/case.png"
            alt=""
            class="visual"
            slot-scope="{ parallax }"
            :style="`transform: translate3d(0px, ${
              parallax && parallax.y ? parallax.y : 0
            }px, 0px)`"
          />
        </parallax>
      </Observer>
    </section>
    <section v-if="page.pantone.clockwise" class="indicator">
      <div class="container">
        <div class="row align-items-center justify-content-center text-center">
          <div class="col-11 col-md-8 col-lg-6">
            <Observer name="fade-up">
              <h2 class="title" v-html="page.pantone.clockwise.title"></h2>
              <p v-html="page.pantone.clockwise.text"></p>
            </Observer>
          </div>
        </div>
      </div>
      <Observer name="fade-up">
        <parallax :from="{ y: 200 }" :to="{ y: -200 }">
          <img
            src="../assets/img/pantone/indicator-1.png"
            alt="Filipe Pantone indicator"
            class="visual-1"
            slot-scope="{ parallax }"
            :style="`transform: translate3d(0px, ${
              parallax && parallax.y ? parallax.y : 0
            }px, 0px)`"
          />
        </parallax>
      </Observer>
      <Observer name="fade-up" :class="'delay-0'">
        <parallax :from="{ y: -200 }" :to="{ y: 200 }">
          <img
            src="../assets/img/pantone/indicator-2.png"
            alt="Filipe Pantone indicator"
            class="visual-2"
            slot-scope="{ parallax }"
            :style="`transform: translate3d(0px, ${
              parallax && parallax.y ? parallax.y : 0
            }px, 0px)`"
          />
        </parallax>
      </Observer>
    </section>
    <section v-if="page.pantone.indexes" class="video">
      <video ref="video" muted playsinline>
        <source src="/assets/img/pantone/case.mp4" type="video/mp4" />
      </video>
      <div class="container">
        <div class="row align-items-center justify-content-center text-center">
          <div class="col-11 col-md-6 col-lg-5 col-xl-4 order-2 order-md-1">
            <Observer @enter.once="playVideo">
              <transition-group name="fade">
                <h2
                  class="title"
                  v-html="page.pantone.indexes.title"
                  v-show="videoFinished"
                  key="title"
                ></h2>
                <p
                  v-html="page.pantone.indexes.text"
                  v-show="videoFinished"
                  key="text"
                ></p>
              </transition-group>
            </Observer>
          </div>
        </div>
      </div>
    </section>
    <section v-if="page.pantone.movement" class="movement -front">
      <Observer name="fade" :root-margin="'-100px'">
        <img
          src="../assets/img/pantone/movement-front.jpg"
          alt=""
          class="visual"
        />
      </Observer>
      <div class="dots" aria-hidden="false">
        <Observer name="fade" :class="'delay-0'">
          <div class="info">1</div>
        </Observer>
        <Observer name="fade" :class="'delay-1'">
          <div class="info">2</div>
        </Observer>
        <Observer name="fade" :class="'delay-2'">
          <div class="info">3</div>
        </Observer>
        <Observer name="fade" :class="'delay-3'">
          <div class="info">4</div>
        </Observer>
      </div>
      <div class="container">
        <Observer name="fade" :class="'delay-0'">
          <div class="info">
            <div class="info-nb" aria-hidden="true">1</div>
            <div
              class="info-title"
              v-html="page.pantone.movement.front.top.right.title"
            ></div>
            <div
              class="info-text"
              v-html="page.pantone.movement.front.top.right.text"
            ></div>
          </div>
        </Observer>
        <Observer name="fade" :class="'delay-1'">
          <div class="info">
            <div class="info-nb" aria-hidden="true">2</div>
            <div
              class="info-title"
              v-html="page.pantone.movement.front.top.left.title"
            ></div>
            <div
              class="info-text"
              v-html="page.pantone.movement.front.top.left.text"
            ></div>
          </div>
        </Observer>
        <Observer name="fade" :class="'delay-2'">
          <div class="info">
            <div class="info-nb" aria-hidden="true">3</div>
            <div
              class="info-title"
              v-html="page.pantone.movement.front.bottom.left.title"
            ></div>
            <div
              class="info-text"
              v-html="page.pantone.movement.front.bottom.left.text"
            ></div>
          </div>
        </Observer>
        <Observer name="fade" :class="'delay-3'">
          <div class="info">
            <div class="info-nb" aria-hidden="true">4</div>
            <div
              class="info-title"
              v-html="page.pantone.movement.front.bottom.right.title"
            ></div>
            <div
              class="info-text"
              v-html="page.pantone.movement.front.bottom.right.text"
            ></div>
          </div>
        </Observer>
      </div>
    </section>
    <!-- section v-if="page.pantone.movement.back" class="movement -back">
      <Observer name="fade" :root-margin="'-100px'">
        <img src="../assets/img/pantone/movement-back.jpg" alt="" class="visual" />
      </Observer>
      <div class="dots" aria-hidden="false">
        <Observer name="fade" :class="'delay-0'">
          <div class="info">1</div>
        </Observer>
        <Observer name="fade" :class="'delay-1'">
          <div class="info">2</div>
        </Observer>
        <Observer name="fade" :class="'delay-2'">
          <div class="info">3</div>
        </Observer>
      </div>
      <div class="container">
        <Observer name="fade" :class="'delay-0'">
          <div class="info">
            <div class="info-nb" aria-hidden="true">1</div>
            <div class="info-title" v-html="page.pantone.movement.back.top.right.title"></div>
            <div class="info-text" v-html="page.pantone.movement.back.top.right.text"></div>
          </div>
        </Observer>
        <Observer name="fade" :class="'delay-1'">
          <div class="info">
            <div class="info-nb" aria-hidden="true">2</div>
            <div class="info-title" v-html="page.pantone.movement.back.top.left.title"></div>
            <div class="info-text" v-html="page.pantone.movement.back.top.left.text"></div>
          </div>
        </Observer>
        <Observer name="fade" :class="'delay-2'">
          <div class="info">
            <div class="info-nb" aria-hidden="true">3</div>
            <div class="info-title" v-html="page.pantone.movement.back.bottom.title"></div>
            <div class="info-text" v-html="page.pantone.movement.back.bottom.text"></div>
          </div>
        </Observer>
      </div>
    </section -->
    <section v-if="page.pantone.editorial" class="content">
      <div class="container">
        <div
          class="row justify-content-center text-center"
          v-if="
            page.pantone.editorial.title || page.pantone.editorial.introduction
          "
        >
          <div class="col-12 col-md-8 col-lg-6">
            <Observer name="fade-up" :class="'delay-0'">
              <h2 class="title" v-html="page.pantone.editorial.title"></h2>
              <p v-html="page.pantone.editorial.introduction"></p>
            </Observer>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12">
            <Observer name="fade-up" :class="'delay-0'">
              <div
                slot-scope="{ parallax }"
                :style="`transform: translate3d(0px, ${
                  parallax && parallax.y ? parallax.y : 0
                }px, 0px)`"
              >
                <video
                  v-if="page.pantone.editorial.video"
                  controls
                  :poster="
                    page.pantone.editorial.cover
                      ? page.pantone.editorial.cover.url
                      : ''
                  "
                  crossorigin="anonymous"
                >
                  <source
                    :src="page.pantone.editorial.video.url"
                    type="video/mp4"
                  />
                  <track
                    v-if="
                      page.pantone.editorial.subtitle &&
                      page.pantone.editorial.subtitle.src &&
                      page.pantone.editorial.subtitle.srclang
                    "
                    kind="captions"
                    :label="page.pantone.editorial.subtitle.label"
                    :srclang="page.pantone.editorial.subtitle.srclang"
                    :src="page.pantone.editorial.subtitle.src"
                    default
                  />
                </video>
                <p class="-big" v-html="page.pantone.editorial.main.text"></p>
              </div>
            </Observer>
          </div>
        </div>
        <div class="row align-items-end justify-content-center">
          <div class="col-12 col-md-5 col-lg-4 offset-md-1 order-1 order-md-2">
            <Observer name="fade-up" :class="'delay-0'">
              <parallax :from="{ y: 100 }" :to="{ y: -100 }">
                <div
                  slot-scope="{ parallax }"
                  :style="`transform: translate3d(0px, ${
                    parallax && parallax.y ? parallax.y : 0
                  }px, 0px)`"
                >
                  <img
                    :src="page.pantone.editorial.top.right.image.url"
                    :alt="page.pantone.editorial.top.right.image.alt"
                    class="visual"
                  />
                  <div
                    class="title-2"
                    aria-hidden="true"
                    v-html="page.pantone.editorial.top.right.title"
                  ></div>
                  <p v-html="page.pantone.editorial.top.right.text"></p>
                </div>
              </parallax>
            </Observer>
          </div>
          <div class="col-12 col-md-5 col-lg-4 order-2 order-md-1">
            <Observer name="fade-up" :class="'delay-0'">
              <parallax :from="{ y: -100 }" :to="{ y: 0 }">
                <div
                  slot-scope="{ parallax }"
                  :style="`transform: translate3d(0px, ${
                    parallax && parallax.y ? parallax.y : 0
                  }px, 0px)`"
                >
                  <img
                    :src="page.pantone.editorial.top.left.image.url"
                    :alt="page.pantone.editorial.top.left.image.alt"
                    class="visual"
                  />
                  <div
                    class="title-2"
                    aria-hidden="true"
                    v-html="page.pantone.editorial.top.left.title"
                  ></div>
                  <p v-html="page.pantone.editorial.top.left.text"></p>
                </div>
              </parallax>
            </Observer>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-5 col-lg-4">
            <Observer name="fade-up" :class="'delay-0'">
              <parallax :from="{ y: 0 }" :to="{ y: 200 }">
                <div
                  slot-scope="{ parallax }"
                  :style="`transform: translate3d(0px, ${
                    parallax && parallax.y ? parallax.y : 0
                  }px, 0px)`"
                >
                  <h3
                    class="a11y-sr-only"
                    v-html="page.pantone.editorial.bottom.left.title"
                  ></h3>
                  <img
                    :src="page.pantone.editorial.bottom.left.image.url"
                    :alt="page.pantone.editorial.bottom.left.image.alt"
                    class="visual"
                  />
                  <div
                    class="title-2"
                    aria-hidden="true"
                    v-html="page.pantone.editorial.bottom.left.title"
                  ></div>
                  <p v-html="page.pantone.editorial.bottom.left.text"></p>
                </div>
              </parallax>
            </Observer>
          </div>
          <div class="col-12 col-md-5 col-lg-4 offset-md-1">
            <Observer name="fade-up" :class="'delay-0'">
              <div>
                <img
                  :src="page.pantone.editorial.center.right.image.url"
                  :alt="page.pantone.editorial.center.right.image.alt"
                  class="visual"
                />
                <div
                  class="title-2"
                  aria-hidden="true"
                  v-html="page.pantone.editorial.center.right.title"
                ></div>
                <p v-html="page.pantone.editorial.center.right.text"></p>
              </div>
            </Observer>
            <Observer name="fade-up" :class="'delay-0'">
              <div>
                <h3
                  class="a11y-sr-only"
                  v-html="page.pantone.editorial.bottom.right.title"
                ></h3>
                <img
                  :src="page.pantone.editorial.bottom.right.image.url"
                  :alt="page.pantone.editorial.bottom.right.image.alt"
                  class="visual"
                />
                <div
                  class="title-2"
                  aria-hidden="true"
                  v-html="page.pantone.editorial.bottom.right.title"
                ></div>
                <p v-html="page.pantone.editorial.bottom.right.text"></p>
              </div>
            </Observer>
          </div>
        </div>
      </div>
    </section>
    <section v-if="page.pantone.product" class="product-purchase container">
      <div class="row justify-content-center align-items-center">
        <div class="col-10 col-md-4 col-lg-3">
          <Observer name="fade-up" :class="'delay-0'">
            <div class="product">
              <lazy-image
                v-if="imageUrl()"
                ref="picture"
                :item="picture()"
                :sizes="pictureSizes"
                root-margin="0px"
              ></lazy-image>
              <span class="name" v-if="page.pantone.product.name">{{
                page.pantone.product.name
              }}</span>
              <span class="text">{{ $t("Limited edition") }}</span>
              <span class="text" v-if="getProductPrice(page.pantone.product)">{{ getProductPrice(page.pantone.product) | currency }}</span>
              <router-link
                :to="
                  localizedUrl + '/product/' + page.pantone.product.routeParam
                "
                class="btn -stroke -icon"
                :aria-label="$t('Discover more')"
              >
                <i :class="'icon-plus'"></i
                ><span>{{ $t("Discover more") }}</span>
              </router-link>
            </div>
          </Observer>
        </div>
      </div>
    </section>
    <CmpRenderer :components="components" key="content"></CmpRenderer>
  </div>
</template>

<script>
import LazyImage from "../components/utils/LazyImage";
import { Parallax } from "leaps/dist/leaps";
import { currentStoreView } from "@vue-storefront/core/lib/multistore";
import { quickSearchByQuery } from "@vue-storefront/core/lib/search";
import SearchQuery from "@vue-storefront/core/lib/search/searchQuery";
import ImageManager from "vue-storefront-prismic-ssr/utilities/ImageManager";
import { PantoneLanding } from "../../../modules/prismic/components/PantoneLanding";
import CmpRenderer from "../components/utils/CmpRenderer";
import { mapActions } from "vuex";
import { getProductPrice } from '../utilities'

export default {
  name: "PantoneLanding",
  mixins: [PantoneLanding],
  components: {
    LazyImage,
    Parallax,
    CmpRenderer,
  },
  computed: {
    localizedUrl() {
      const { url } = currentStoreView();
      return url;
    },
    dataToolbar() {
      return this.components.find(({ component }) => component === 'generic_toolbar')
    }
  },
  data() {
    return {
      isEcommerce: false,
      sticky: false,
      stickyHeader: false,
      isMobile: false,
      videoFinished: false,
      pictureSizes: "(max-width: 768px) 80vw, (max-width: 992px) 26vw, 40vw",
      imageSizes: {
        width: 0,
        height: 0,
      },
      esProduct: null,
    };
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
    window.addEventListener("resize", this.windowResize);
    window.addEventListener("scroll", this.headerPosition);
    const interval = setInterval(() => {
      if (
        this.page &&
        this.page.pantone &&
        this.page.pantone.product &&
        this.page.pantone.product.sku
      ) {
        const { sku } = this.page.pantone.product;
        this.fetchProduct(sku).then((p) => {
          this.esProduct = p;
        });
        clearInterval(interval);
      }
    }, 100);
  },
  created() {
    this.isEcommerce = this.$store.state["zenith-ui"].ecommerce;
  },
  methods: {
    getProductPrice: getProductPrice,
    ...mapActions("cart", { addToCart: "addItem" }),
    ...mapActions("feedback", ["show"]),
    fetchProduct(sku) {
      const storeView = currentStoreView();
      const productQuery = ({ sku }) => {
        let query = new SearchQuery();
        query = query.applyFilter({ key: "sku", value: { eq: sku } });
        return query;
      };
      return quickSearchByQuery({
        query: productQuery({ sku }),
        entityType: "product",
        storeCode: storeView.storeCode,
      }).then(({ items }) => items[0]);
    },
    addToCartAndFeedback(product, p) {
      let size = null;
      try {
        size = {
          option_value:
            this.esProduct.custom_options[0].values[0].option_type_id.toString(),
          option_id: this.esProduct.custom_options[0].option_id.toString(),
        };
      } catch (error) {}
      const payload = size
        ? {
            productToAdd: {
              ...product,
              product_option: {
                extension_attributes: { custom_options: [size] },
              },
            },
          }
        : { productToAdd: product };
      this.addToCart(payload).then(() => {
        /* this.show({
          message: "Your product has been added to your shopping bag",
        }); */
      });
    },
    playVideo() {
      this.$refs.video.play();
      setTimeout(() => {
        this.videoFinished = true;
      }, 2000);
    },
    windowResize() {
      this.isMobile = window.innerWidth < 768;
    },
    headerPosition() {
      this.sticky = document
        .querySelector("#header-site")
        .classList.contains("-fixed");
      this.stickyHeader = document
        .querySelector("#header-site")
        .classList.contains("-show");
    },
    imageUrl() {
      if (
        this.page.pantone &&
        this.page.pantone.product &&
        this.page.pantone.product.image
      ) {
        return ImageManager.convert(
          this.page.pantone.product.image,
          "image",
          "product"
        );
      } else return null;
    },
    picture() {
      return this.page.pantone.product
        ? {
            url: this.imageUrl(),
            lowDefinitionUrl: ImageManager.getLowDefinition(
              this.imageUrl(),
              70,
              1.4285714286,
              false,
              4
            ),
            srcset: ImageManager.getSrcSet(
              this.imageUrl(),
              1000,
              200,
              100,
              1.4285714286
            ),
            alt: this.page.pantone.product.name,
            width: this.imageSizes.width,
            height: this.imageSizes.height,
          }
        : {
            url: this.imageUrl(),
            lowDefinitionUrl: ImageManager.getLowDefinition(
              this.imageUrl(),
              70,
              1.4285714286,
              false,
              4
            ),
            srcset: ImageManager.getSrcSet(
              this.imageUrl(),
              1000,
              200,
              100,
              1.4285714286
            ),
            alt: "Product",
            width: this.imageSizes.width,
            height: this.imageSizes.height,
          };
    },
    onClickScrollDown() {
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth",
      });
    },
  },
  destroyed: function () {
    window.removeEventListener("resize", this.windowResize);
    window.removeEventListener("scroll", this.headerPosition);
  },
};
</script>

<style lang="scss" scoped>
@import "~theme/css/core";

.pantone {
  @include bp(md) {
    .container {
      max-width: 1200px;
    }
  }
}

header {
  position: absolute;
  z-index: 30;
  top: 0;
  width: 100%;
  padding: 2rem 0;
  background: var(--zenith-white);
  transition: all 0.2s ease-in-out, transform 0s;
  @include bp(max md) {
    padding: 1rem 0;
  }

  .container {
    width: 100%;
    max-width: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .star {
    position: relative;
    top: -0.2rem;
    width: 2.6rem;
    margin-right: 1rem;
  }

  .title {
    font-size: em(21);
    font-weight: bold;
    letter-spacing: em(1, 21);
    text-transform: uppercase;
    margin-right: auto;
    margin-bottom: 0;
    @include bp(max md) {
      font-size: em(18);
      font-weight: bold;
      letter-spacing: em(1, 18);
    }
  }

  &.-withToolbar {
    transform: translateY(8rem);
    @include bp(max md) {
      transform: translateY(5rem);
    }
  }

  &.-sticky {
    position: fixed;
    transition: all 0.2s ease-in-out;
    transform: translateY(0);

    &.-stickyHeader {
      transform: translateY(12rem);
      @include bp(max md) {
        transform: translateY(9rem);
      }

      &.-withToolbar {
        transform: translateY(20rem);
        @include bp(max md) {
          transform: translateY(14rem);
        }
      }
    }
  }

  .btn {
    cursor: pointer;
    font-weight: 400;

    @include bp(max md) {
      padding: 0.2rem 2rem 0 4rem;

      span {
        display: none;
      }
    }
    &:after {
      border-radius: 0;
      border-color: rgba(26, 35, 43, 0.2);
    }
  }
}

section {
  .title {
    display: block;
    color: #13171b;
    font-size: em(40);
    line-height: em(44, 40);
    margin-bottom: 2rem;
    text-transform: uppercase;
    @include bp(max md) {
      font-size: em(26);
      line-height: em(30, 26);
    }
  }
  .title-2 {
    color: #13171b;
    font-size: em(26);
    font-weight: bold;
    line-height: em(32, 26);
    margin-bottom: 2rem;
    @include bp(max md) {
      font-size: em(20);
      line-height: em(24, 20);
      margin-bottom: 1rem;
    }
  }
  legend {
    font-size: em(12);
    line-height: em(22, 12);
  }
  p {
    font-weight: 500;
    font-size: em(16);
    line-height: em(22, 16);
  }
}
.signature {
  position: relative;
  height: calc(100vh - 12rem);
  display: flex;
  align-items: center;
  justify-content: center;

  @include bp(max md) {
    height: calc(100vh - 8rem);
  }

  img,
  video {
    width: 100%;
    max-width: 70rem;

    @include bp(max md) {
      width: 92%;
      margin-left: 4%;
    }
  }
}

.watch {
  // margin-top: -20rem;
  padding: 0 0 20rem 0;

  .col-12:first-child {
    z-index: 10;
  }

  @include bp(max md) {
    padding: 4rem 0 8rem;
  }

  @include bp(max md) {
    .col-md-8 {
      & > div {
        transform: none !important;
      }
    }
  }

  img {
    width: 100%;
    max-width: 60rem;
  }
}

.work {
  position: relative;
  padding: 16rem 0;

  @include bp(max md) {
    padding: 4rem 0 6rem;
  }

  & > .obs {
    position: absolute;
    z-index: 10;
    top: 0;
    width: 100%;
    height: 60%;
    overflow: hidden;
  }
  .works {
    position: absolute;
    z-index: 10;
    top: 0;
    width: 100%;
    height: 100%;

    &:after {
      position: absolute;
      display: block;
      z-index: 10;
      content: "";
      width: 100%;
      height: 100%;
      background: black;
      opacity: 0.47;
    }

    img {
      position: absolute;
      min-width: 50%;
      min-height: calc(100% + 40rem);

      &:first-child {
        top: -20rem;
        left: 0;

        @include bp(max md) {
          top: 0;
          transform: none !important;
        }
      }

      &:last-child {
        bottom: -20rem;
        left: 50%;

        @include bp(max md) {
          bottom: 0;
          transform: none !important;
        }
      }
    }
  }

  .visual {
    display: block;
    max-width: 60rem;
    width: 90%;
    margin: 0 auto 9rem;
    box-shadow: 0 11px 39px 0 rgba(0, 0, 0, 0.5);

    @include bp(max md) {
      width: 100%;
      margin: 0 auto 6rem;
    }
  }

  .container {
    position: relative;
    z-index: 10;
  }
}

.case {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background: #f3f3f3;
  display: flex;
  align-items: center;

  @include bp(max lg) {
    height: 70vh;
  }

  @include bp(max md) {
    height: auto;
    padding-bottom: 6rem;
    text-align: center;
    flex-direction: column;
  }

  & > .obs {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    @include bp(max md) {
      position: static;
    }
  }

  .visual {
    position: absolute;
    z-index: 10;
    left: 50%;
    width: 50%;
    max-width: 50rem;
    margin-left: -50rem;

    @media (max-width: 1200px) {
      max-width: 40rem;
      margin-left: -40rem;
    }

    @include bp(max lg) {
      max-width: 25rem;
      margin-left: -35rem;
    }

    @include bp(max md) {
      position: static;
      order: 1;
      width: 100%;
      margin: 6rem auto;
      transform: none !important;
    }
  }

  .container {
    position: relative;
    z-index: 20;
    height: 100%;
    .row {
      height: 100%;
    }
    @include bp(max md) {
      position: static;
      order: 2;
    }
  }
}

.movement {
  position: relative;
  height: 90vh;
  min-height: 90rem;
  overflow: hidden;
  background: #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;

  @include bp(max lg) {
    display: block;
    height: auto;
    min-height: 45rem;
    padding-bottom: 6rem;
  }

  & > .obs {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @include bp(max lg) {
      display: block;
      position: static;
    }
  }

  .dots {
    display: block;
    z-index: 25;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 37rem;
    height: 37rem;
    max-width: 100%;
    max-height: 100vw;
    transform: translate(-50%, -50%);

    @include bp(max lg) {
      top: 10rem;
      transform: translate(-50%, 0);
    }

    @include bp(max md) {
      width: 25rem;
      height: 25rem;
    }

    .info {
      display: none;
      width: 3rem;
      line-height: 2.8rem;
      color: #6c6c6c;
      border: 1px solid #6c6c6c;
      border-radius: 100%;
      text-align: center;

      @include bp(max lg) {
        display: inline-block;
      }
    }

    /deep/ .obs {
      &:after {
        display: block;
        content: "";
        position: absolute;
        width: 0.1rem;
        height: 18rem;
        background: #6c6c6c;

        @media (max-width: 1200px) {
          height: 10rem;
        }

        @include bp(max md) {
          height: 8rem;
        }
      }
    }
  }

  .visual {
    position: absolute;
    z-index: 10;
    display: block;
    max-width: 37rem;

    @include bp(max lg) {
      position: static;
      display: block;
      margin: 10rem auto 8rem;
    }

    @include bp(max md) {
      max-width: 25rem;
    }
  }

  .container {
    height: 100%;

    @include bp(max lg) {
      .obs-fade {
        margin: 0 !important;
      }
    }
  }

  .info {
    &-title {
      font-size: em(20);
      line-height: em(30, 20);
      font-weight: bold;
      margin-bottom: 0.8rem;
    }

    &-text {
      font-weight: 500;
      font-size: em(14);
      line-height: em(20, 14);
    }

    &-nb {
      display: none;
      width: 3rem;
      line-height: 2.8rem;
      color: #6c6c6c;
      border: 1px solid #6c6c6c;
      border-radius: 100%;
      text-align: center;
      position: absolute;
      left: 4rem;

      @include bp(max lg) {
        display: inline-block;
      }

      @include bp(max md) {
        left: 1.5rem;
      }
    }
  }

  div .obs {
    position: absolute;
    z-index: 20;
    width: 30rem;
    top: 50%;
    left: 50%;
  }

  &.-front {
    background: white;

    /deep/ .delay-0 {
      transform: translate(1.1rem, calc(-100% - 11.5rem));
      transition: all 0.4s ease-in-out, transform 0.8s $Power3EaseOut,
        opacity 0.6s $SineEaseOut;

      @include bp(max md) {
        transform: translate(0.8rem, calc(-100% - 7.8rem));
      }
      &.obs-fade {
        margin: -2rem 0 0 2rem;
        @include bp(max lg) {
          width: 3rem;
          .info {
            transform: none;
          }
        }
        @include bp(max md) {
          margin: 0;
        }
      }

      .info {
        transform: translate(14rem, -14rem);

        @media (max-width: 1200px) {
          transform: translate(8rem, -8rem);
        }
        @include bp(max md) {
          transform: translate(6rem, -6rem);
        }
      }
    }

    /deep/ .delay-1 {
      text-align: right;
      transform: translate(calc(-100% - 9.6rem), calc(-100% - 7.2rem));
      transition: all 0.4s 0.2s ease-in-out, transform 0.8s 0.2s $Power3EaseOut,
        opacity 0.6s 0.2s $SineEaseOut;

      @include bp(max md) {
        transform: translate(calc(-100% - 6.5rem), calc(-100% - 5rem));
      }
      &.obs-fade {
        margin: -2rem 0 0 -2rem;
        @include bp(max lg) {
          width: 3rem;
          .info {
            transform: none;
          }
        }
        @include bp(max md) {
          margin: 0;
        }
      }

      .info {
        transform: translate(-14rem, -14rem);

        @media (max-width: 1200px) {
          transform: translate(-8rem, -8rem);
        }
        @include bp(max md) {
          transform: translate(-6rem, -6rem);
        }
      }
    }

    /deep/ .delay-2 {
      text-align: right;
      transform: translate(calc(-100% - 9.6rem), 9rem);
      transition: all 0.4s 0.4s ease-in-out, transform 0.8s 0.4s $Power3EaseOut,
        opacity 0.6s 0.4s $SineEaseOut;

      @include bp(max md) {
        transform: translate(calc(-100% - 6.5rem), 6rem);
      }
      &.obs-fade {
        margin: 2rem 0 0 -2rem;
        @include bp(max lg) {
          width: 3rem;
          .info {
            transform: none;
          }
        }
        @include bp(max md) {
          margin: 0;
        }
      }

      .info {
        transform: translate(-14rem, 14rem);

        @media (max-width: 1200px) {
          transform: translate(-8rem, 8rem);
        }
        @include bp(max md) {
          transform: translate(-6rem, 6rem);
        }
      }
    }

    /deep/ .delay-3 {
      transform: translate(7rem, 10.5rem);
      transition: all 0.4s 0.6s ease-in-out, transform 0.8s 0.6s $Power3EaseOut,
        opacity 0.6s 0.6s $SineEaseOut;

      @include bp(max md) {
        transform: translate(5.5rem, 6.5rem);
      }
      &.obs-fade {
        margin: 2rem 0 0 2rem;
        @include bp(max lg) {
          width: 3rem;
          .info {
            transform: none;
          }
        }
        @include bp(max md) {
          margin: 0;
        }
      }

      .info {
        transform: translate(14rem, 14rem);

        @media (max-width: 1200px) {
          transform: translate(8rem, 8rem);
        }
        @include bp(max md) {
          transform: translate(6rem, 6rem);
        }
      }
    }

    .dots {
      /deep/ .delay-0 {
        &:after {
          bottom: 0;
          left: 0;
          transform-origin: bottom left;
          transform: rotate(45deg);
        }
      }
      /deep/ .delay-1 {
        &:after {
          bottom: 0;
          right: 0;
          transform-origin: bottom right;
          transform: rotate(-45deg);
        }
      }
      /deep/ .delay-2 {
        &:after {
          top: 0;
          right: 0;
          transform-origin: top right;
          transform: rotate(45deg);
        }
      }
      /deep/ .delay-3 {
        &:after {
          top: 0;
          left: 0;
          transform-origin: top left;
          transform: rotate(-45deg);
        }
      }
    }

    .container /deep/ .obs {
      @include bp(max lg) {
        position: static;
        width: 100%;
        margin-bottom: 2rem;
        text-align: left;
        transform: none;

        .info {
          transform: none;
          padding-left: 4rem;
        }
      }
    }
  }

  &.-back {
    /deep/ .delay-0 {
      transform: translate(9.7rem, calc(-100% - 7.2rem));
      transition: all 0.4s ease-in-out, transform 0.8s $Power3EaseOut,
        opacity 0.6s $SineEaseOut;

      @include bp(max md) {
        transform: translate(5rem, calc(-100% - 7.8rem));
      }
      &.obs-fade {
        margin: -2rem 0 0 2rem;
        @include bp(max lg) {
          width: 3rem;
        }
        @include bp(max md) {
          margin: 0;
        }
      }

      .info {
        transform: translate(14rem, -14rem);

        @media (max-width: 1200px) {
          transform: translate(8rem, -8rem);
        }
        @include bp(max md) {
          transform: translate(6rem, -6rem);
        }
      }
    }

    /deep/ .delay-1 {
      text-align: right;
      transform: translate(calc(-100% - 10rem), calc(-100% - 1rem));
      transition: all 0.4s 0.2s ease-in-out, transform 0.8s 0.2s $Power3EaseOut,
        opacity 0.6s 0.2s $SineEaseOut;

      @media (max-width: 1200px) {
        transform: translate(calc(-100% - 12rem), calc(-100% - 1rem));
      }
      @include bp(max md) {
        transform: translate(calc(-100% - 6.6rem), calc(-100% - 5rem));
      }
      &.obs-fade {
        margin: -2rem 0 0 -2rem;
        @include bp(max lg) {
          width: 3rem;
        }
        @include bp(max md) {
          margin: 0;
        }
      }

      .info {
        transform: translate(-14rem, -14rem);

        @media (max-width: 1200px) {
          transform: translate(-8rem, -8rem);
        }
        @include bp(max md) {
          transform: translate(-6rem, -6rem);
        }
      }
    }

    /deep/ .delay-2 {
      transform: translate(9.7rem, 3.2rem);
      transition: all 0.4s 0.4s ease-in-out, transform 0.8s 0.4s $Power3EaseOut,
        opacity 0.6s 0.4s $SineEaseOut;

      @include bp(max md) {
        transform: translate(0.5rem, 6.9rem);
      }
      &.obs-fade {
        margin: 2rem 0 0 2rem;
        @include bp(max lg) {
          width: 3rem;
        }
        @include bp(max md) {
          margin: 0;
        }
      }

      .info {
        transform: translate(14rem, 14rem);

        @media (max-width: 1200px) {
          transform: translate(8rem, 8rem);
        }
        @include bp(max md) {
          transform: translate(6rem, 6rem);
        }
      }
    }

    .dots {
      /deep/ .delay-0 {
        &:after {
          bottom: 0;
          left: 0;
          transform-origin: bottom left;
          transform: rotate(45deg);
        }
      }
      /deep/ .delay-1 {
        &:after {
          bottom: 0;
          right: 0;
          transform-origin: bottom right;
          transform: rotate(-45deg);
        }
      }
      /deep/ .delay-2 {
        &:after {
          top: 0;
          left: 0;
          transform-origin: top left;
          transform: rotate(-45deg);
        }
      }
    }

    .container /deep/ .obs {
      @include bp(max lg) {
        position: static;
        width: 100%;
        margin-bottom: 2rem;
        text-align: left;
        transform: none;
        transition: all 0.4s ease-in-out;

        .info {
          transform: none;
          padding-left: 4rem;
        }
      }
    }
  }
}

.indicator {
  position: relative;
  height: 100vh;
  overflow: hidden;

  & > .obs {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }

  @include bp(max md) {
    height: auto;
    padding: 28rem 0 6rem;
  }

  .visual-1 {
    position: absolute;
    left: 10%;
    top: 50%;
    margin-top: -27rem;
    width: 20rem;

    @media (max-width: 1200px) {
      left: 5%;
    }
    @include bp(max lg) {
      left: -3rem;
    }
    @include bp(max md) {
      width: 8rem;
      left: 50%;
      top: 4.8rem;
      margin-top: 0;
      transform: translateX(-100%) !important;
    }
  }

  .visual-2 {
    position: absolute;
    right: 10%;
    top: 50%;
    margin-top: -30rem;
    width: 20rem;

    @media (max-width: 1200px) {
      right: 5%;
    }
    @include bp(max lg) {
      right: 0;
    }
    @include bp(max md) {
      right: auto;
      left: 50%;
      top: 2rem;
      width: 8rem;
      margin-top: 0;
      transform: rotate(180deg) !important;
    }
  }

  .container {
    height: 100%;
    .row {
      height: 100%;
    }
  }
}

.video {
  position: relative;
  height: 120rem;
  overflow: hidden;
  background: #f3f3f4;

  @media (max-width: 1200px) {
    height: 80rem;
  }

  @include bp(max md) {
    height: auto;
  }

  .container {
    z-index: 20;

    .row {
      height: 120rem;
      padding: 12rem 0;

      @media (max-width: 1200px) {
        height: 80rem;
      }

      @include bp(max lg) {
        height: 80rem;
      }

      .title {
        margin-top: 4rem;
        @include bp(max md) {
          margin-top: 0;
        }
      }

      @include bp(max md) {
        height: auto;
        padding: 0 0 6rem;

        .delay-10 {
          transition: all 0.4s ease-in-out, transform 0.8s $Power3EaseOut,
            opacity 0.6s $SineEaseOut;
        }
      }
    }
  }

  video {
    position: absolute;
    z-index: 10;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
    transform: translate(-50%, -50%);

    @media (max-width: 1200px) {
      width: 120%;
      height: 120%;
    }

    @include bp(max lg) {
      width: 140%;
      height: 140%;
    }

    @include bp(max md) {
      position: static;
      transform: none;
      width: 100%;
      height: 100%;
      margin: -4rem 0;
    }
  }
}

.content {
  padding: 10rem 0 2rem;
  overflow: hidden;
  max-width: 100%;

  @include bp(max md) {
    padding: 4rem 0 2rem;
  }

  @include bp(max md) {
    .col-12 {
      text-align: center;
      margin-bottom: 6rem;
      @include bp(max md) {
        margin-bottom: 6rem;
      }

      .obs > div {
        transform: none !important;
      }
    }
  }

  .inverse {
    width: 100%;
    display: flex;
    flex-direction: column;
    img {
      order: 2;
      margin-top: 4rem;

      @include bp(max md) {
        order: 0;
        margin-top: 0;
      }
    }
  }

  .row {
    &:not(:last-child) {
      margin-bottom: 10rem;
      @include bp(max md) {
        margin-bottom: 0;
      }
    }

    p {
      font-size: em(20);
      line-height: em(36, 20);

      @include bp(max md) {
        font-size: em(16);
        padding: 0 1.5rem;
        line-height: em(24, 16);
      }

      &.-sm {
        font-weight: 500;
        font-size: em(14);
        line-height: em(20, 14);
      }

      &.-big {
        width: 70%;
        margin: auto;
        font-size: em(26);
        font-weight: 500;
        line-height: em(40, 26);
        text-align: center;

        @include bp(max md) {
          width: 100%;
          font-size: em(20);
          line-height: em(36, 20);
        }
      }

      & + img {
        margin-top: 4rem;
        @include bp(max md) {
          margin-top: 2rem;
        }
      }
    }
    .obs + .obs {
      margin-top: 8rem;
      @include bp(max md) {
        margin-top: 6rem;
      }
    }
  }
  .order-1 {
    margin-bottom: 8rem;
    @include bp(max md) {
      margin-bottom: 6rem;
    }
  }
  video {
    outline: none;
    max-width: 100%;
    margin-bottom: 8rem;

    @include bp(max md) {
      margin-bottom: 6rem;
    }
  }
  .visual {
    margin-bottom: 4rem;
    @include bp(max md) {
      margin-bottom: 2rem;
    }

    &.-lg {
      max-width: 180%;

      @include bp(max md) {
        max-width: 100%;
      }
    }
  }
}

.product {
  display: flex;
  margin: auto;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  & > /deep/ .obs {
    width: 100%;
    height: 100%;
  }

  .name {
    color: #13171b;
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
  }

  .text {
    opacity: 0.7;
    color: #13171b;
    margin-bottom: 1rem;
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
    & + .text {
      margin-bottom: 2rem;
    }
  }

  .btn {
    font-weight: 400;

    &:after {
      border-radius: 0;
      border-color: rgba(26, 35, 43, 0.2);
    }

    i {
      display: inline-block;
    }
  }

  .lazy-image {
    width: 100%;
    margin-bottom: 2rem;

    /deep/ img {
      width: 90%;
      margin: auto;
      display: block;

      @include bp(max md) {
        width: 100%;
      }
    }
  }

  &-purchase {
    padding-top: 10rem;
    padding-bottom: 2rem;

    @include bp(max md) {
      padding-top: 2rem;
    }
  }
}

.scrollto {
  position: absolute;
  left: 50%;
  z-index: 25;
  bottom: 4rem;
  width: 4.8rem;
  color: #000000;
  padding: 1.3rem 0;
  border-radius: 100%;
  border: 1px solid rgba(26, 35, 43, 0.2);
  background: transparent;
  transform: translateX(-50%);
  display: block;

  @include bp(max md) {
    width: 3.8rem;
    padding: 1rem 0;
    bottom: 3.7rem;
  }

  i {
    display: block;
    font-size: em(20);
    line-height: 2rem;
    animation: bouncing 1.2s infinite ease-in-out;

    @include bp(max md) {
      font-size: em(15);
      line-height: 1.5rem;
    }
  }

  &:hover,
  &:active,
  &:focus {
    background: var(--zenith-theme-primary);
    color: var(--zenith-white);
  }
}

@keyframes bouncing {
  0%,
  100% {
    transform: translateY(-0.3rem);
  }
  25% {
    transform: translateY(0.7rem);
  }
}
</style>
